// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"PasswordSaveConfirmedModal_modalContainer__bZpQv","headerText":"PasswordSaveConfirmedModal_headerText__riWps"};